<script>
import TrekLoading from '@/components/TrekLoading';

export default {
  name: 'OrderDetails',

  components: {
    TrekLoading,
  },

  props: {
    checkoutStep: {
      type: String,
      default: '',
    },
    partTypeKey: {
      type: String,
      default: '',
    },
    orderDetails: {
      type: Object,
      default: () => {},
    },
    bikesOrderCode: {
      type: String,
      default: '',
    },
    bikesOrderUpdate: {
      type: String,
      default: '',
    },
    partsOrderCode: {
      type: String,
      default: '',
    },
    partsOrderUpdate: {
      type: String,
      default: '',
    },
    timeoutError: {
      type: Boolean,
    },

    isDropShip: Boolean,
  },

  data() {
    return {
      loading: true,
    };
  },
};
</script>
